'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.accordion =
  twentyninetimes.accordion ||
  (function () {
    function init() {
      const accordions = document.querySelectorAll('.js-accordion')
      if (accordions) {
        // accordions.forEach(accordion => {
        // 	var toggle 	= accordion.querySelector('.js-accordion-toggle'),
        // 		content = accordion.querySelector('.js-accordion-content');

        // 	accordionToggle(accordion, toggle, content);
        // });

        document.addEventListener('click', (e) => {
          e.stopPropagation()

          var target = e.target,
            toggle = target.closest('.js-accordion-toggle')

          if (
            target.classList.contains('js-accordion-toggle') ||
            target.closest('.js-accordion-toggle')
          ) {
            var faq = toggle.closest('.js-accordion'),
              content = faq.querySelector('.js-accordion-content')

            toggleAccordion(faq, toggle, content)

            if (faq.classList.contains('link-box--dropdown')) {
              var parent = faq.parentNode

              if (parent.classList.contains('has-active-accordion')) {
                parent.classList.remove('has-active-accordion')
              } else {
                parent.classList.add('has-active-accordion')
              }
            }
          } else {
            return
          }
        })
      }

      const rank_math_faqs = document.querySelectorAll('.rank-math-list-item')
      if (rank_math_faqs) {
        rank_math_faqs.forEach((faq) => {
          var toggle = faq.querySelector('.rank-math-question'),
            content = faq.querySelector('.rank-math-answer')

          toggle.addEventListener('click', function (event) {
            event.stopPropagation()

            toggleAccordion(faq, toggle, content)
          })
        })
      }
    }

    function toggleAccordion(accordion, toggle, content) {
      let expanded = toggle.getAttribute('aria-expanded') === 'true' || false
      toggle.setAttribute('aria-expanded', !expanded)

      if (!accordion.classList.contains('active')) {
        accordion.classList.add('active')

        content.style.height = 'auto'
        var accordionHeight = content.clientHeight
        content.style.height = '0px'

        setTimeout(function () {
          accordion.classList.add('active')
          content.style.height = accordionHeight + 'px'

          setTimeout(function () {
            if (accordion.classList.contains('active')) {
              content.style.height = 'auto'
            }
          }, 600)
        }, 10)
      } else {
        var accordionHeight = content.clientHeight
        content.style.height = accordionHeight + 'px'

        setTimeout(function () {
          content.style.height = '0px'
          accordion.classList.remove('active')
        }, 10)
      }
    }

    return {
      init: init,
    }
  })()
